export default __webpack_public_path__ + "static/media/BerlinTypeWeb-Bold.df67eb2d.woff2";